import { withAITracking } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "app-insights";
import RootPage from "pages/RootPage";
import localisations from "../../shell/localisation";
import { Alert, Grid, Typography } from "@mui/material";
import { getFieldCompanyId } from "shell/services/fieldCompanyService";
import { useAuth0 } from "@auth0/auth0-react";
import { useState } from "react";
import { ConsistencyCheckTable } from "domains/consistency-check/components/consistency-check-table";

function ConsistencyCheckPage() {
    const {
        consistencyCheck: { heading, blurb, reportCreationDateBlurb, errorMessage, warningMessage },
    } = localisations.pages;
    const { user } = useAuth0();
    const [error, setError] = useState(false);
    const [warning, setWarning] = useState(false);
    const [lastUpdatedDateTime, setLastUpdatedDateTime] = useState("");

    const handleOnError = (err: boolean) => {
        setError(err);
    }

    const handleLastUpdatedDateTime = (dateTime: string) => {
        if (isNaN(Date.parse(dateTime))) {
            dateTime = "unknown";
            return;
        }
        const lastUpdated = new Date(dateTime);
        const ukDate = lastUpdated.toLocaleDateString("en-GB");
        setLastUpdatedDateTime(ukDate);
        setWarning(new Date().getTime() - lastUpdated.getTime() > 3 * 24 * 60 * 60 * 1000);
    };

    const fieldCompanyId = getFieldCompanyId(user);

    return (
        <RootPage header={heading}>
            {error && (<Alert severity='error'>{errorMessage}</Alert>)}
            {!error && (<Grid container spacing={2}>
                <Grid item xs={12}>
                    <Typography variant="body1" gutterBottom>
                        {blurb}
                    </Typography>
                    <Typography variant="body1" gutterBottom style={{ color: 'grey' }}>
                        {`${reportCreationDateBlurb} ${lastUpdatedDateTime}`}
                    </Typography>
                </Grid>
                {warning && <Alert style={{ marginLeft: '15px' }} severity="error">{warningMessage}</Alert>}
                <Grid item xs={12}>
                    <ConsistencyCheckTable fieldCompanyId={fieldCompanyId} onLastUpdatedDateTime={handleLastUpdatedDateTime} setColumnMenu={true} onError={handleOnError} />
                </Grid>
            </Grid>
            )}
        </RootPage>
    );
}

export default withAITracking(reactPlugin, ConsistencyCheckPage, "Consistency Check Page")